import { makeStyles } from '@material-ui/core';
import { BuildOutlined, Language, Router } from '@material-ui/icons';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import React, { useEffect, useState } from 'react';
import { useObservable } from 'react-use-observable';
import { ACCOUNTS_ENV, BRANCH_NAME, BUILD_DATE, BUILD_NUMBER, ENV, IS_PROD } from 'settings';
import { dateFormat } from 'v2/formatters/date';
import apiService from 'v2/services/api';

const useStyles = makeStyles(() => ({
  staticTooltipLabel: {
    width: 240,
    color: 'white',
    fontSize: 12,
    background: '#192542',
    textAlign: 'left',
  },
}));

export default () => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [version] = useObservable(() => apiService.get('/version'), []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    console.info(ENV);

    if (process.env.REACT_APP_BUILD_NUMBER) {
      console.info(`${process.env.REACT_APP_BUILD_NUMBER} ${process.env.REACT_APP_BUILD_DATE}`);
    }

    if (process.env.REACT_APP_BUILD_VERSION) {
      console.info(`Build version: ${process.env.REACT_APP_BUILD_VERSION}`);
    }

    if (!IS_PROD) {
      console.info(`Accounts: ${ACCOUNTS_ENV}`);
    }
  }, []);

  if (IS_PROD || version === null) return null;

  const actions = [
    { icon: <Router />, name: `API - ${version.environment} ${version.branchName} ${dateFormat(version.versionDate, 'dd/MM/yyyy HH:mm:ss')}` },
    { icon: <Language />, name: `FRONT - ${ENV} ${BRANCH_NAME} ${BUILD_NUMBER} ${dateFormat(BUILD_DATE, 'dd/MM/yyyy HH:mm:ss')}` },
  ];

  return (
    <SpeedDial
      ariaLabel='Env info'
      style={{ position: 'fixed', bottom: 16, left: 16 }}
      icon={<BuildOutlined />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          tooltipPlacement='right'
          classes={classes}
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          tooltipOpen
          onClick={handleClose}
        />
      ))}
    </SpeedDial>
  );
};
